export const MDRT_ID_COOKIE_NAME = 'mdrtId';
